<div class="home-container">
  <div
    class="navbar-container flex w-full justify-center items-center px-4 fixed"
  >
    <div class="navbar-main-container flex w-full justify-between items-center">
      <div class="logoAndMenuList-container flex w-full items-center">
        <div class="logo-container flex w-full items-center gap-2">
          <div><img src="assets/images/logo.svg" alt="logo" /></div>

          <div class="nav-icons" style="display: flex; margin-inline-start: 1rem; gap: 0.5rem">

            <div role="link" (click)="redirectToExplore()">
              <svg
                class="home-link"
                width="2rem"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M18.5 3H16C15.7239 3 15.5 3.22386 15.5 3.5V3.55891L19 6.35891V3.5C19 3.22386 18.7762 3 18.5 3Z"
                    fill="#fff"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.75 9.5C10.75 8.80964 11.3097 8.25 12 8.25C12.6904 8.25 13.25 8.80964 13.25 9.5C13.25 10.1904 12.6904 10.75 12 10.75C11.3097 10.75 10.75 10.1904 10.75 9.5Z"
                    fill="#fff"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.75 10.9605L21.5315 11.5857C21.855 11.8444 22.3269 11.792 22.5857 11.4685C22.8444 11.1451 22.792 10.6731 22.4685 10.4143L14.3426 3.91362C12.9731 2.81796 11.027 2.81796 9.65742 3.91362L1.53151 10.4143C1.20806 10.6731 1.15562 11.1451 1.41438 11.4685C1.67313 11.792 2.1451 11.8444 2.46855 11.5857L3.25003 10.9605V21.25H2.00003C1.58581 21.25 1.25003 21.5858 1.25003 22C1.25003 22.4142 1.58581 22.75 2.00003 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H20.75V10.9605ZM9.25003 9.5C9.25003 7.98122 10.4812 6.75 12 6.75C13.5188 6.75 14.75 7.98122 14.75 9.5C14.75 11.0188 13.5188 12.25 12 12.25C10.4812 12.25 9.25003 11.0188 9.25003 9.5ZM12.0494 13.25C12.7143 13.25 13.2871 13.2499 13.7459 13.3116C14.2375 13.3777 14.7088 13.5268 15.091 13.909C15.4733 14.2913 15.6223 14.7625 15.6884 15.2542C15.7462 15.6842 15.7498 16.2146 15.75 16.827C15.75 16.8679 15.75 16.9091 15.75 16.9506L15.75 21.25H14.25V17C14.25 16.2717 14.2484 15.8009 14.2018 15.454C14.1581 15.1287 14.0875 15.0268 14.0304 14.9697C13.9733 14.9126 13.8713 14.842 13.546 14.7982C13.1991 14.7516 12.7283 14.75 12 14.75C11.2717 14.75 10.8009 14.7516 10.4541 14.7982C10.1288 14.842 10.0268 14.9126 9.9697 14.9697C9.9126 15.0268 9.84199 15.1287 9.79826 15.454C9.75162 15.8009 9.75003 16.2717 9.75003 17V21.25H8.25003L8.25003 16.9506C8.24999 16.2858 8.24996 15.7129 8.31163 15.2542C8.37773 14.7625 8.52679 14.2913 8.90904 13.909C9.29128 13.5268 9.76255 13.3777 10.2542 13.3116C10.7129 13.2499 11.2858 13.25 11.9507 13.25H12.0494Z"
                    fill="#fff"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.75 9.5C10.75 8.80964 11.3097 8.25 12 8.25C12.6904 8.25 13.25 8.80964 13.25 9.5C13.25 10.1904 12.6904 10.75 12 10.75C11.3097 10.75 10.75 10.1904 10.75 9.5Z"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <p style="font-size: 0.8rem">Home</p>
            </div>

            <div role="link" (click)="redirectToGallery()">
              <svg
                class="home-link"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8Z"
                    fill="#ffff"
                  ></path>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62178 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62178 21.25 12C21.25 12.4502 21.2499 12.8764 21.2487 13.2804L21.0266 13.2497C18.1828 12.8559 15.5805 14.3343 14.2554 16.5626C12.5459 12.2376 8.02844 9.28807 2.98073 10.0129L2.75497 10.0454C2.76633 8.63992 2.80368 7.52616 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z"
                    fill="#ffff"
                  ></path>
                </g>
              </svg>
              <p style="font-size: 0.8rem">Gallery</p>
            </div>
          </div>
        </div>

        <!-- Tab list -->
        <div role="tablist" class="navbar-menu-list-container flex w-full">
          <ng-container *ngFor="let item of navbarMenu">
            <div
              class="menu-list"
              *ngIf="role == item.role"
              (click)="switchTab(item)"
              role="tab"
            >
              <a [routerLink]="item.href" routerLinkActive="active-menu-item">{{
                item.value
              }}</a>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- // Search form -->
      <div class="searchAndProfile-container flex justify-between items-center">
        <div class="navbar-search" *ngIf="role !== 'ARTIST'">
          <div class="seach-expand" [class.guest-mode]="role === 'GUEST'">
            <form
              class="navbar-search-form"
              [formGroup]="searchForm"
              (ngSubmit)="goToSearch()"
            >
              <div
                class="search-animation w-100 h-100"
                [class.guest-mode]="role === 'GUEST'"
              >
                <div class="icon" (click)="searchField.focus()">
                  <img src="assets/images/image_search.svg" alt="search" />
                </div>
                <input
                  #searchField
                  formControlName="search"
                  type="text"
                  placeholder="Search artworks"
                />
              </div>
            </form>
            <div
              class="recent-search"
              *ngIf="role !== 'GUEST'"
              tabindex="1"
              #recentSearchList
            >
              <h4 class="title">Recently Searched</h4>
              <ul>
                <li
                  class="tag"
                  (click)="searchFromKeyword(keyword); recentSearchList.blur()"
                  *ngFor="let keyword of recentSearchKeywords"
                >
                  {{ keyword }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          class="notificaiton pointer"
          style="position: relative"
          *ngIf="role !== roleEnum.GUEST"
        >
          <div
            [attr.aria-value]="unreadCount"
            [class.count-badge]="unreadCount"
            (click)="toggleNotificationMenu()"
          >
            <img src="assets/images/notifications_unread.svg" alt="" />
          </div>
          <div
            class="drop-down-container notification"
            [class.show]="isNotificationMenuOpen"
            appClickOutside
            [isOpen]="isNotificationMenuOpen"
            (clickOutside)="closeNotificationMenu()"
          >
            <div class="dropdown-menu">
              <h3 class="title">Notifications</h3>
              <ul lazyLoader (lazyLoad)="getNextPage()" #viewMarker>
                <li
                  class="notification-wrapper"
                  [attr.data-id]="notification.notificationId"
                  [attr.data-read]="notification.read ? '' : null"
                  *ngFor="let notification of notificationList"
                >
                  <div>
                    <p>{{ notification?.notificationMessage || "" }}</p>
                    <p class="timestamp">
                      <time>{{
                        (notification?.notificationTime
                          | date: "dd MMM, yyyy") || ""
                      }}</time>
                    </p>
                  </div>
                  <div
                    class="image-count"
                      [attr.data-count]="notification.artUploadThumbnailUrlList?.length > 1
                        ? notification.artUploadThumbnailUrlList.length - 1
                        : null"
                    >
                    <img
                      *ngIf="notification?.artUploadThumbnailUrlList?.length"
                      [src]="notification.artUploadThumbnailUrlList[0]"
                      alt=""
                    />
                  </div>
                </li>
                <div
                  *ngIf="notificationPagination.isLoading"
                  class="loader-overlay"
                >
                  <div class="spinner"></div>
                </div>
              </ul>
              <div class="top-arrow" style="z-index: -1"></div>
            </div>
          </div>
        </div>

        <!-- prifile icon -->
        <div
          *ngIf="role !== roleEnum.GUEST"
          class="user-profile flex flex-nowrap items-center gap-2 pointer"
          (click)="menuShow(); $event.stopPropagation()"
        >
          <div class="profile-photo">
            <img
              [src]="profilePic"
              onerror="this.src = 'assets/images/dummyP.jpg'"
              class="photo"
              alt="profile"
            />
          </div>
          <div>
            <img src="assets/images/down_arrow.svg" alt="" />
          </div>
        </div>

        <!-- Dropdown Menu -->
        <div
          class="drop-down-container"
          [class.show]="isMenuVisible"
          appClickOutside
          [isOpen]="isMenuVisible"
          (clickOutside)="closeMenu()"
        >
          <div class="dropdown-menu">
            <ul>
              <!-- Role Switch with Radio Buttons -->
              <li class="menu-item role-switch">
                <label class="role">
                  <input
                    id="audience"
                    type="radio"
                    name="role"
                    value="audience"
                    [checked]="role === roleEnum.AUDIENCE"
                    (change)="onRoleUpdate(roleEnum.AUDIENCE)"
                  />
                  <span>User</span>
                </label>
              </li>
              <li class="menu-item role-switch">
                <label class="role flex">
                  <input
                    id="artist"
                    type="radio"
                    name="role"
                    value="artist"
                    [checked]="role === roleEnum.ARTIST"
                    (change)="onRoleUpdate(roleEnum.ARTIST)"
                  />
                  <span> Artist </span>
                </label>
              </li>

              <!-- Other Menu Items with Icons -->
              <li class="menu-item" [routerLink]="'/gallery/profile'">
                <img src="assets/images/account_menu.svg" alt="Profile" />
                Profile Settings
              </li>
              <li class="menu-item" routerLink="/gallery/payment">
                <img src="assets/images/add_card.svg" alt="Payment" />
                Payment
              </li>
              <li class="menu-item" routerLink="/gallery/bank-details">
                <svg
                  fill="#1a2b47"
                  viewBox="1 2 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                  class="bank-svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zm-2.526 3.104a.318.318 0 0 0-.317-.316h-.372v-.384a.318.318 0 0 0-.316-.316h-.55V7.214h.866a.396.396 0 0 0 .158-.76L8.658 4.416a.396.396 0 0 0-.315 0L3.64 6.454a.396.396 0 0 0 .158.76h.865v4.457h-.549a.318.318 0 0 0-.316.316v.384h-.372a.318.318 0 0 0-.317.316v.383h10.782zM5.455 7.954h1.502v3.717H5.455zm5.839-1.532H5.706L8.5 5.212zM7.749 7.954h1.502v3.717H7.75zm2.294 0h1.502v3.717h-1.502z"
                    ></path>
                  </g>
                </svg>
                Bank Details
              </li>
              <li class="menu-item log-out" (click)="logout()">
                <img src="assets/images/move_item.svg" alt="Logout" />
                Log Out
              </li>
            </ul>
            <div class="top-arrow"></div>
          </div>
        </div>

        <!-- ======================================== GUEST ================================== -->
        <div *ngIf="role === 'GUEST'">
          <app-button routerLink="/auth/login" text="Log in"></app-button>
        </div>
      </div>
    </div>

    <menu role="menu" *ngIf="role !== roleEnum.GUEST">
      <button
        class="navbar-trigger"
        popovertarget="navbar"
        style="
          background-color: transparent;
          border: 2px solid oklch(from var(--clr-400) l c h / 0.4);
          border-radius: 0.3rem;
        "
      >
        <svg
          width="2rem"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g id="Menu / Menu_Alt_01">
              <path
                id="Vector"
                d="M12 17H19M5 12H19M5 7H19"
                stroke="#FFFFFF"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
          </g>
        </svg>
      </button>

      <ul id="navbar" popover #popover>
        <button class="close-popup-btn" (click)="popover.hidePopover()">
          <span class="sr-only">Close</span>
          x
        </button>
        <li>
          <div
            class="searchAndProfile-container flex justify-between items-center"
          >
            <!-- profile icon -->
            <div
              *ngIf="role === roleEnum.ARTIST || role === roleEnum.AUDIENCE"
              class="user-profile flex flex-nowrap items-center gap-2 pointer"
              (click)="menuShow(); $event.stopPropagation()"
            >
              <div class="profile-photo">
                <img
                  [src]="profilePic"
                  onerror="this.src = 'assets/images/dummyP.jpg'"
                  class="photo"
                  alt="profile"
                />
              </div>
              <p>{{userName}}</p>
              <div>
                <img src="assets/images/down_arrow.svg" alt="" />
              </div>
            </div>

            <!-- Dropdown Menu -->
            <div
              *ngIf="isMobile"
              class="drop-down-container"
              [class.show]="isMenuVisible"
              appClickOutside
              [isOpen]="isMenuVisible"
              (clickOutside)="closeMenu()"
            >
              <div class="dropdown-menu">
                <ul>
                  <!-- Role Switch with Radio Buttons -->
                  <li class="menu-item role-switch">
                    <label class="role">
                      <input
                        id="audience"
                        type="radio"
                        name="role"
                        value="audience"
                        [checked]="role === roleEnum.AUDIENCE"
                        (change)="onRoleUpdate(roleEnum.AUDIENCE);popover.hidePopover()"
                      />
                      <span>User</span>
                    </label>
                  </li>
                  <li class="menu-item role-switch">
                    <label class="role flex">
                      <input
                        id="artist"
                        type="radio"
                        name="role"
                        value="artist"
                        [checked]="role === roleEnum.ARTIST"
                        (change)="onRoleUpdate(roleEnum.ARTIST);popover.hidePopover()"
                      />
                      <span> Artist </span>
                    </label>
                  </li>

                  <!-- Other Menu Items with Icons -->
                  <li (click)="popover.hidePopover()" class="menu-item" role="link" [routerLink]="'/gallery/profile'">
                    <img src="assets/images/account_menu.svg" alt="Profile" />
                    Profile Settings
                  </li>
                  <li (click)="popover.hidePopover()" class="menu-item" routerLink="/gallery/payment">
                    <img src="assets/images/add_card.svg" alt="Payment" />
                    Payment
                  </li>
                  <li (click)="popover.hidePopover()" class="menu-item" routerLink="/gallery/bank-details">
                    <svg
                      fill="#1a2b47"
                      viewBox="1 2 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      class="bank-svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zm-2.526 3.104a.318.318 0 0 0-.317-.316h-.372v-.384a.318.318 0 0 0-.316-.316h-.55V7.214h.866a.396.396 0 0 0 .158-.76L8.658 4.416a.396.396 0 0 0-.315 0L3.64 6.454a.396.396 0 0 0 .158.76h.865v4.457h-.549a.318.318 0 0 0-.316.316v.384h-.372a.318.318 0 0 0-.317.316v.383h10.782zM5.455 7.954h1.502v3.717H5.455zm5.839-1.532H5.706L8.5 5.212zM7.749 7.954h1.502v3.717H7.75zm2.294 0h1.502v3.717h-1.502z"
                        ></path>
                      </g>
                    </svg>
                    Bank Details
                  </li>
                  <li (click)="popover.hidePopover()" class="menu-item log-out" (click)="logout()">
                    <img src="assets/images/move_item.svg" alt="Logout" />
                    Log Out
                  </li>
                </ul>
                <div class="top-arrow"></div>
              </div>
            </div>

            <!-- ======================================== GUEST ================================== -->
            <div *ngIf="(role !== roleEnum.ARTIST && role !== roleEnum.AUDIENCE)">
              <app-button routerLink="/auth/login" text="Log in"></app-button>
            </div>
          </div>
        </li>

        <ng-container *ngFor="let item of navbarMenu">
          <li
            class="menu-list"
            *ngIf="role == item.role"
            (click)="switchTab(item)"
            role="tab"
          >
            <a (click)="popover.hidePopover()" [routerLink]="item.href" routerLinkActive="active-menu-item">{{
              item.value
            }}</a>
          </li>
        </ng-container>
      </ul>
    </menu>
  </div>

  <div class="router-contaier">
    <router-outlet *ngIf="!isSearchAble"></router-outlet>

    <app-show-search-details
      [searchTerm]="searchKeywords || ''"
      [images]="SearchData"
      *ngIf="isSearchAble"
      (fetchNextPage)="getSearchData(false)"
      (close)="closeSearch()"
      [totalArts]="totalSearch"
      [noDataFound]="noData"
    ></app-show-search-details>
  </div>
</div>
